module.exports = __webpack_public_path__ + "static/media/example-3.b5d60779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/example-3.jpg
// module id = 214
// module chunks = 0